export const getNumberInputValue = (input) => {
  const numericValue = parseInt(input, 10);
  return !isNaN(numericValue) ? numericValue : 0;
};
